export interface NewPersonPayload {
  name: string;
  email: string;
  phone?: string;
  company_id?: string;
  position_id?: string;
  title?: string;
  flag_comments?: string;
}

export interface NewCompanyPayload {
  name: string;
  email: string;
  phone?: string;
  type_id?: string;
  flag_comments?: string;
}

export interface Person {
  person_id: string;
  name: string;
  email: string;
  company: { company_id: string; name: string };
  position: { value: string };
  preferences?: { color?: string };
}

export interface Company {
  company_id: string;
  name: string;
  email?: string;
  type?: { value: string } | string | null;
  type_id?: string | null;
  phone?: string | null;
  flag?: boolean | null;
  flag_comments?: string | null;
  flagComments?: string | null;
}

interface BerthCalls {
  status: string | null;
  operations:
    | {
        tank_inspection?: string | null;
        parcel: number | null;
        quantity: number | null;
        quantity_type: string | null;
        grade: string | null;
        charterer: string | null;
        status: string | null;
      }[]
    | null;
}

export interface BerthRotation {
  name: string;
  berth_id: string;
  anchored_hours: number | null;
  shifting_hours: number | null;
  eta: string | null;
  etd: string | null;
  status: string | null;
  lock_fact: boolean | null;
  parent_type: string | null;
  port: string | null;
  gates: string | null;
}

export interface CargoOperationExtended {
  cargo_id: string;
  charterer: string | null;
  grade: string | null;
  orders: boolean | null;
  parcel: number | null;
  options: string | null;
  internal_notes: string | null;
  quantity: number | null;
  quantity_type: string | null;
  status: string | null;
  stowage: string | null;
  surveyor: string | null;
  tank_inspection_notes: string | null;
  tank_inspection: string | null;
  "3461_entry": string | null;
  bill_of_lading: string | null;
  received_ams_id: string | null;
}

export interface Delivery {
  delivery_vendor_id: string;
  delivery_date: string | null;
  delivery_type: string | null;
  dock_location: string;
  launch: string | null;
  pallet_count: number | null;
  vendor: string | null;
  for_account_notes: string | null;
  job_id: string;
  for_account_id: string;
  berth_id: string;
  vender_id: string;
}

export interface Bunker {
  bfw_id: string;
  delivery_date: string | null;
  supplier: string | null;
  dock_location: string;
  mts: string | null;
  pallet_count: number | null;
  type: string | null;
}

export interface OnBoardService {
  obf_id: string;
  date_completed: string | null;
  dock_location: string;
  type_of_service: string | null;
  vendor: string | null;
}

export interface BerthCallExtended extends BerthCalls {
  berth_id: string;
  name: string;
  type: string | null;
  status: string | null;
  eta: string | null;
  etd: string | null;
  operations: CargoOperationExtended[] | null;
  deliveries: Delivery[] | null;
  on_board_services: OnBoardService[] | null;
  bunkers: Bunker[] | null;
}

export interface BerthExtended {
  portcall_name: string | null;
  pc_id: string;
  showBerthTable: boolean | null;
  calls: BerthCallExtended[] | null;
}

interface PortCall {
  port_callings_id: string;
  port_callings_name: string;
  charter_company_id: string | null;
  tug_company_id: string | null;
  mooring_company_id: string | null;
  launch_company_id: string | null;
  waste_company_id: string | null;
  closures?: { active: boolean; status: string; type: string; date: string }[];
}

export interface VesselJob {
  job_id: string;
  vessel: string;
  voyage: string;
  status: string;
  current_status?: string;
  vessel_id: string;
  imo?: string;
  vessel_email?: string;
  company_id: string;
  assigned_agent?: { name: string };
  assigned_agent_id?: string;
  persons?: NotificationContact[];
  berths?: BerthExtended[];
  operator?: string;
  turn_over_notes?: string;
  berth_rotations?: BerthRotation[];
  management?: {
    management_id: string;
    management_name: string;
  };
  appointed_operator?: boolean;
  port_calls?: PortCall[];
  attachments?: { file_name: string; type_id?: string }[];
}

export interface NotificationContact {
  person_id?: string;
  company_id?: string;
  company_name?: string;
  company_email?: string;
  type?: string;
  person_name?: string;
  person_email?: string;
  recipient_id: string;
}

export interface VesselNotification {
  vessel_id: string;
  vessel_name: string;
  jobs: VesselJob[];
}

export interface Vessel {
  vessel_id: string;
  name: string;
  email: string;
  company_id: string;
  voyage?: string;
  imo?: string;
  company?: { company_id: string; name: string };
  notifications?: VesselNotification;
  outlook_folder:string| null;
}

export interface Recipient {
  emailAddress: { name: string; address: string; id?: string };
  isManual?: boolean;
}
export interface Attachment {
  id: string;
  name: string;
  contentType: string;
  size: number;
  isInline?: boolean;
  contentId?: string;
  voyages: string[];
  linkedDocumentIds?: string[];
  signedVersions?: {
    documentId: string;
    fileName: string;
    url: string;
    versionId: string;
  }[];
}

export interface EmailListItem {
  to: Recipient[];
  id: string;
  ccRecipients: Recipient[];
  conversationId?: string | null;
  conversationIndex?: string | null;
  subject: string;
  from: Recipient;
  // toRecipients: Recipient[];
  receivedDateTime: string;
  isRead: boolean;
  bodyPreview: string;
  hasAttachments?: boolean;
  voyages?: string[];
  processed: boolean;
  voyageJobs: VesselJob[];
  sender: Recipient;
  attachments: Attachment[];
  categories?: string[];
  parentFolderId?: string;
}

export interface EmailDetails {
  id: string;
  subject: string;
  from: Recipient;
  sender: Recipient;
  toRecipients: Recipient[];
  ccRecipients: Recipient[];
  bccRecipients?: Recipient[];
  body: { contentType: "html" | "text"; content: string };
  attachments: Attachment[];
  sentDateTime: string;
  receivedDateTime?: string;
  isRead?: boolean;
  hasAttachments?: boolean;
  conversationId?: string | null;
  conversationIndex?: string | null;
  parentFolderId?: string;
  flagged?: boolean;
  categories?: string[];
}

export interface MashedEmail {
  email: EmailListItem;
  person: Person | null;
  company: Company | null;
  vessels: Vessel[];
  vessel?: any | null;
  status?: "Classified" | "Draft" | "Resolved" | "Needs Attention";
}

export type EmailViewMode = "flat" | "conversation";

export interface EmailConversation {
  id: string;
  conversationId: string | null;
  messages: MashedEmail[];
  latestMessage: MashedEmail;
  subject: string;
  participants: string[];
  unreadCount: number;
  hasAttachments: boolean;
  messageCount: number;
}

export interface ConversationMessage extends EmailDetails {
  to?: Recipient[];
  processed?: boolean;
  voyages?: string[];
  voyageJobs?: VesselJob[];
}

export interface DocumentType {
  document_type_id: string;
  display_text: string;
}
export interface Documents {
  type_id: string;
  file_name: string;
  document_id: string;
  job_id: string;
  modified_at: string;
  modified_by: string;
  mime_type: string;
  size: number;
}

export interface PickList {
  id: string;
  value: string;
  type: string;
  parent_type: string;
}

export interface OutlookFolder {
  id: string;
  displayName: string;
  parentFolderId: string;
  childFolderCount: number;
  childFolders: OutlookFolder[];
  totalItemCount: number;
  unreadItemCount: number;
}

// ── Mailbox ────────────────────────────────────────────────────────────────

export type MailboxKey = "personal" | "tma" | "nh3" | "docs";

export interface MailboxOption {
  key: MailboxKey;
  label: string;
}

export const MAILBOX_OPTIONS: MailboxOption[] = [
  { key: "personal", label: "My Inbox" },
  { key: "tma",      label: "TMA Inbox" },
  { key: "nh3",      label: "NH3" },
  { key: "docs",     label: "Docs" },
];

export const DEFAULT_MAILBOX: MailboxKey = "tma";

export const MAILBOX_LABELS = MAILBOX_OPTIONS.reduce(
  (labels, option) => {
    labels[option.key] = option.label;
    return labels;
  },
  {} as Record<MailboxKey, string>,
);

const MAILBOX_ADDRESS_TO_KEY: Record<string, MailboxKey> = {
  "docs@tma-usgulf.com": "docs",
  "nh3@tma-usgulf.com": "nh3",
  "tma@tma-usgulf.com": "tma",
  // Personal mailbox addresses are user-specific and cannot be mapped
  // statically. Records stored with mailbox_key = "personal" are resolved by
  // isMailboxKey() above and never reach this map.
};

export const isMailboxKey = (value: unknown): value is MailboxKey =>
  typeof value === "string" &&
  MAILBOX_OPTIONS.some((option) => option.key === value);

export const normalizeMailboxKey = (
  value: unknown,
  fallback: MailboxKey = DEFAULT_MAILBOX,
): MailboxKey => {
  if (isMailboxKey(value)) return value;
  if (typeof value !== "string") return fallback;

  return MAILBOX_ADDRESS_TO_KEY[value.trim().toLowerCase()] ?? fallback;
};

export interface LLMBerthRotation {
  name: string;
  port: string;
  eta: string;
  etd: string;
  status: string;
  anchoredHours?: number;
  shiftingHours?: number;
}

export interface LLMCargoOperation {
  berthName: string;
  parcel?: number;
  charterer?: string;
  grade?: string;
  quantity?: number;
  quantityType?: string;
  status?: string;
  stowage?: string;
  surveyor?: string;
  tankInspection?: string;
}

export interface LLMDelivery {
  berthName: string;
  deliveryDate?: string;
  deliveryType?: string;
  dockLocation?: string;
  launch?: string;
  palletCount?: number;
  vendor?: string;
  forAccountNotes?: string;
}

export interface LLMOnBoardService {
  berthName: string;
  dateCompleted?: string;
  dockLocation?: string;
  typeOfService?: string;
  vendor?: string;
}

export interface LLMBunker {
  berthName: string;
  deliveryDate?: string;
  supplier?: string;
  dockLocation?: string;
  mts?: string;
  palletCount?: number;
  type?: string;
}

export interface LLMJobContext {
  vesselName: string;
  vesselImo?: string;
  voyage: string;
  jobStatus: string;
  agentName?: string;

  // Management & Operator
  operator?: string;
  managementCompany?: string;
  appointedOperator?: boolean;

  // Berth Rotations with aggregates
  berthRotations?: LLMBerthRotation[];
  totalAnchoredHours?: number;
  totalShiftingHours?: number;

  // Cargo Operations
  cargoOperations?: LLMCargoOperation[];

  deliveries?: LLMDelivery[];
  onBoardServices?: LLMOnBoardService[];
  bunkers?: LLMBunker[];

  // Port Information
  portClosures?: string[];

  // Notes
  turnOverNotes?: string;
  latestUpdate?: string;
}


export interface ComposerTab {
  id: string;
  mode: "port-call";
  label: string;
  editorInitialContent?: string;
  recipients?: {
    email: string|null;
    id: string;
    name: string|null;
  }[];
  subject?: string;
  companyId?: string
  companyCategory?:string
  terminalBerthIds?: string[]
  hasMissingEmail?: boolean;
  isAllArrangements?: boolean;
}

export interface JobCompany {
  company_id: string;
  email?: string; // Optional, in case some vendors don’t have emails
  name: string;
  phone?: string; // Optional, in case phone numbers are missing
  type: string;
}

export interface PortCallCompanyList {
  charterer: JobCompany[];
  delivery_vendor_vendors: JobCompany[];
  bunkers_freshwater_suppliers: JobCompany[];
  surveyor: JobCompany[];
  on_board_service_vendors: JobCompany[];
  terminals: JobCompany[];
  job_id: string;
}

export const CATEGORY_LABELS: Record<
  keyof Omit<PortCallCompanyList, "job_id">,
  string
> = {
  charterer: "Charterer",
  delivery_vendor_vendors: "Delivery Vendor",
  bunkers_freshwater_suppliers: "Bunkers/FW Supplier",
  surveyor: "Surveyor",
  on_board_service_vendors: "OB Service Vendor",
  terminals: "Terminal",
};
